module.exports = __webpack_public_path__ + "img/sankaku_89_red.e43d32de.png";